'use strict';
import Swiper from 'swiper';


export default class ServicesSlider {
  constructor() {
    this.name = 'services-slider';
    var mySwiper = new Swiper ('.services-slider-swiper', {
      // Optional parameters
      loop: true,
  
      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
      },
    });
  }
}
